import { Controller } from "@hotwired/stimulus";
import "./component.scss";

// Search + pick list for the retroactive affiliate assignment. The candidates
// are fully server-rendered; this only filters them by substring, reflects the
// picked one and fills the hidden membership field. Submit stays disabled until
// something is picked, so the form can never post without a membership.
export default class extends Controller {
  static targets = ["input", "item", "empty", "field", "submit"];

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase();
    let visible = 0;

    this.itemTargets.forEach((item) => {
      const show = query === "" || (item.dataset.term || "").includes(query);
      item.closest("li").hidden = !show;
      if (show) visible += 1;

      // A pick the filter just hid must not stay submittable — the visible list
      // and the hidden field would disagree about who receives the commission.
      if (!show && item.classList.contains("is-active")) this.deselect(item);
    });

    if (this.hasEmptyTarget) this.emptyTarget.hidden = visible !== 0;
  }

  deselect(item) {
    item.classList.remove("is-active");
    item.setAttribute("aria-selected", "false");
    this.fieldTarget.value = "";
    this.submitTarget.disabled = true;
  }

  // Collapses the surrounding <details> the plus button opened; the picked
  // state is kept so reopening continues where the user left off.
  close() {
    this.element.closest("details")?.removeAttribute("open");
  }

  // Clicking anywhere outside the open panel (plus button included — it lives
  // in the same <details>) closes it, like any select-style popover.
  closeOnOutsideClick(event) {
    const details = this.element.closest("details");
    if (!details?.open || details.contains(event.target)) return;

    details.removeAttribute("open");
  }

  select(event) {
    const item = event.currentTarget;

    this.fieldTarget.value = item.dataset.membershipId;
    this.itemTargets.forEach((other) => {
      const active = other === item;
      other.classList.toggle("is-active", active);
      other.setAttribute("aria-selected", active ? "true" : "false");
    });
    this.submitTarget.disabled = false;
  }
}
